import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const announcementDet = () => import('@/components/views/announcementDet')
const privacyPolicy = () => import('@/components/views/privacyPolicy')
const messageDet = () => import('@/components/views/messageDet')
const sxx = () => import('@/components/views/sxx')
const sxyf = () => import('@/components/views/sxyf')
const bst = () => import('@/components/views/bst')
export default new Router({
  routes: [
    { path: '/announcementDet',name: 'announcementDet',component: announcementDet, meta:{title:"闪星侠"} },
    { path: '/privacyPolicy',name: 'privacyPolicy',component: privacyPolicy, meta:{title:"闪星侠"} },
    { path: '/messageDet',name: 'messageDet',component: messageDet, meta:{title:"闪星侠"} },
    { path: '/sxx',name: 'messageDet',component: sxx, meta:{title:"闪星侠"} },
    { path: '/bst',name: 'bst',component: bst, meta:{title:"BST服务"} },
    { path: '/sxyf',name: 'messageDet',component: sxyf, meta:{title:"闪星云服"} }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js